var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('a',{staticClass:"back",on:{"click":function($event){return _vm.$emit('back')}}},[_c('img',{attrs:{"src":"https://img2.233.com/wx/union/wap/leadaclass/back-icon.png"}})]),_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }